module.exports = __webpack_public_path__ + "static/media/BrownTS_5PageWritingSample.0d20a597.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/manuscript/BrownTS_5PageWritingSample.pdf
// module id = 389
// module chunks = 0